import React, { useEffect, useState, useRef, useContext } from 'react';

//*************************Componentes PrimerReact**************************************** */
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

import AgGrid from '../../../../../../Base/Components/Tables/AgGrid/AgGrid';
import Loader from '../../../../../../Base/Components/Loader/Loader';
import { AuthContext } from '../../../../../../Base/Context/AuthContext/AuthContext';

import { getIngresosServicios } from '../../../../../../API/Suministros/IngresosBodega/IngresosBodegaDetalleRequest';
import { ObtenerCurrency } from '../../../../../../Base/API/Global/Currency/CurrencyRequest';
import { getBalanceIngresos, getCategoriasLiquidaciones, postAplicarMontoDetalles, postLiquidacionesDetalles } from '../../../../../../API/Suministros/Liquidaciones/LiquidacionesRequest';

import { useForm } from '../../../../../../Base/Hooks/useForm';
import { toastShow } from '../../../../../../Base/Services/ToastService';
import { getDateTimeStringSQL } from '../../../../../../Base/Services/Moment/Luxon';
import { RedondearNumero } from '../../../../../../utils/Funciones/FuncionesGenerales';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import Card from '../../../../../../Base/Components/Card/Card';


const OverlayLiquidaciones = ({valoresIngreso, AsignarLiquidacion, habilitar, close, info, detalles, serviciosNuevo, showPOColumn, guardarIngresosBodega, guardarIngresos, getIngreso}) => {

    const op = useRef(null);
    const buttom = useRef(null)
    const toast = useRef(null)
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [monedas, setMonedas] = useState([]);
    const [selected, setSelected] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [letraE, setLetraE] = useState(null);
    
    const initialValues = {
        IdCurrency: 1,
        MontoFleteD: 0,
        MontoDesaduanajeD: 0,
        MontoEmbalajeD: 0,
        MontoOtrosCostosD: 0,

        MontoFleteL: 0,
        MontoDesaduanajeL: 0,
        MontoEmbalajeL: 0,
        MontoOtrosCostosL: 0
    }

    const { values, setValues, handleChange, handleInputChange, resetForm } = useForm(initialValues)

    const { userAuth } = useContext(AuthContext)
    const [hiddenPriceColumn, setHiddenPriceColumn] = useState(userAuth?.AccessWeb.split(",").map((e) => parseInt(e)).includes(29));

    const getInfo = async () => {
        setLoading(true)

        
        const tempoCategorias = await getCategoriasLiquidaciones()
        setCategorias(tempoCategorias)

        const result = await getIngresosServicios()
        // setData(dataTempo)

        if (result?.length > 0) {
            let tempoData = result?.map((r) => {
                let CL
                if (tempoCategorias.length > 0) { 
                    CL = tempoCategorias.find((t) => r?.NombreSubcategoria && r.NombreSubcategoria.toLowerCase().includes(t.CategoriaLiquidacion.toLowerCase()))
                }
                return {
                    ...r,
                    IdCategoriaLiquidacion: CL ? CL.IdCategoriaLiquidacion : 4,
                    CategoriaLiquidacion: CL ? CL.CategoriaLiquidacion : 'Otros Costos',
                    Currency: r.Currency,
                    MontoAplicadoL: r.BalanceLiquidacionL,
                    MontoAplicadoD: r.BalanceLiquidacionD

                }
            })
            setData(tempoData)
        }

        const monedasTempo = await ObtenerCurrency()
        setMonedas(monedasTempo.filter(i => i?.IdCurrency !== 3 ))

        setLoading(false)
    }

    const CambiarMontoAplicar = async (rowData, nuevo, moneda) => {
        let det = rowData
        let BalanceLiquidacionL, BalanceLiquidacionD
        let tempoBalanceL = 0, tempoBalanceD = 0


        const tempoBalanceDet = await getBalanceIngresos(det?.IdIngresoDetalle)
        if (tempoBalanceDet.length > 0) {
            tempoBalanceD = tempoBalanceDet[0]?.MontoAplicadoD
            tempoBalanceL = tempoBalanceDet[0]?.MontoAplicadoL
            
        }

        if (moneda === 1) {
            det.MontoAplicadoD = nuevo
            det.MontoAplicadoL = RedondearNumero(nuevo * det.TasaCambio)

            BalanceLiquidacionD = RedondearNumero(det.CostoD - (det.MontoAplicadoD + tempoBalanceD))
            BalanceLiquidacionL = RedondearNumero(det.CostoL - (det.MontoAplicadoL + tempoBalanceL))

            let BD = BalanceLiquidacionD
            if (BD < 0) {
                det.MontoAplicadoD = 0
                det.MontoAplicadoL = 0
                det.BalanceLiquidacionD = RedondearNumero(det.CostoD - (tempoBalanceD))
                det.BalanceLiquidacionL = RedondearNumero(det.CostoL - (tempoBalanceL))
                toastShow(toast, 'error', 'El monto que desea asignar supera el balance del detalle')
            } else {
                det.MontoAplicadoD = nuevo
                det.MontoAplicadoL = RedondearNumero(nuevo * det.TasaCambio)
                det.BalanceLiquidacionD = BalanceLiquidacionD
                det.BalanceLiquidacionL = BalanceLiquidacionL
            }
        } else {

            det.MontoAplicadoL = nuevo
            det.MontoAplicadoD = RedondearNumero(nuevo / det.TasaCambio)


            BalanceLiquidacionD = RedondearNumero(det.CostoD - (det.MontoAplicadoD + tempoBalanceD))
            BalanceLiquidacionL = RedondearNumero(det.CostoL - (det.MontoAplicadoL + tempoBalanceL))


            let BL = BalanceLiquidacionL
            if (BL < 0) {
                det.MontoAplicadoL = 0
                det.MontoAplicadoD = 0
                det.BalanceLiquidacionL = RedondearNumero(det.CostoL - (tempoBalanceL))
                det.BalanceLiquidacionD = RedondearNumero(det.CostoD - (tempoBalanceD))
                toastShow(toast, 'error', 'Error' ,'El monto que desea asignar supera el balance del detalle')
            } else {
                det.MontoAplicadoL = nuevo
                det.MontoAplicadoD = RedondearNumero(nuevo / det.TasaCambio)
                det.BalanceLiquidacionD = BalanceLiquidacionD
                det.BalanceLiquidacionL = BalanceLiquidacionL
            }
        }

        const tempo = [...data]
        const index = tempo.findIndex((detail) => detail?.IdIngresoDetalle === det?.IdIngresoDetalle)
        tempo[index] = det
        setData(tempo)
    }

    
    const AsignarInformacion = (e, datosAsignar) => {
        if (datosAsignar?.length > 0) {
            let valoresDesaduanajeD = (datosAsignar?.filter((d) => d.IdCategoriaLiquidacion === 1).reduce((t, v) => t + v.MontoAplicadoD, 0))
            let valoresFleteD = (datosAsignar?.filter((d) => d.IdCategoriaLiquidacion === 2).reduce((t, v) => t + v.MontoAplicadoD, 0))
            let valoresEmbalajeD = (datosAsignar?.filter((d) => d.IdCategoriaLiquidacion === 3).reduce((t, v) => t + v.MontoAplicadoD, 0))
            let valoresOtrosCostosD = (datosAsignar?.filter((d) => d.IdCategoriaLiquidacion === 4).reduce((t, v) => t + v.MontoAplicadoD, 0))

            let valoresDesaduanajeL = (datosAsignar?.filter((d) => d.IdCategoriaLiquidacion === 1).reduce((t, v) => t + v.MontoAplicadoL, 0))
            let valoresFleteL = (datosAsignar?.filter((d) => d.IdCategoriaLiquidacion === 2).reduce((t, v) => t + v.MontoAplicadoL, 0))
            let valoresEmbalajeL = (datosAsignar?.filter((d) => d.IdCategoriaLiquidacion === 3).reduce((t, v) => t + v.MontoAplicadoL, 0))
            let valoresOtrosCostosL = (datosAsignar?.filter((d) => d.IdCategoriaLiquidacion === 4).reduce((t, v) => t + v.MontoAplicadoL, 0))

            let tempoValues = { ...values }
            tempoValues.MontoEmbalajeD = valoresEmbalajeD
            tempoValues.MontoFleteD = valoresFleteD
            tempoValues.MontoDesaduanajeD = valoresDesaduanajeD
            tempoValues.MontoOtrosCostosD = valoresOtrosCostosD

            tempoValues.MontoEmbalajeL = valoresEmbalajeL
            tempoValues.MontoFleteL = valoresFleteL
            tempoValues.MontoDesaduanajeL = valoresDesaduanajeL
            tempoValues.MontoOtrosCostosL = valoresOtrosCostosL

            setValues(tempoValues)
            AsignarLiquidacion(e, tempoValues, op)
        }


    }

    const ActualizarInformacion = async (e) => {
        if (selected.length > 0) {
            let datosCategorizados = selected?.filter((s) => s.IdCategoriaLiquidacion && [1, 2, 3, 4].includes(s.IdCategoriaLiquidacion))

            if (datosCategorizados?.length > 0) {
                setShowDialog(true)
                AsignarInformacion(e, datosCategorizados)
                setLetraE(e)
            } else {
                toastShow(toast, 'warn', 'Advertencia','Debe asignar un categorización correcta a valores que sea asignar');
                setSelected([])
            }
        } else {
            toastShow(toast, 'error', 'Error','Debe seleccionar el detalle que desea asignar');
        }
    }

    const guardarLiquidacion = async () => {
        let datosActualizar = selected.map((s) => {
            return {
                ...s,
                IdUserEdit: userAuth?.IdUser,
                FechaEdit: getDateTimeStringSQL(new Date())
            }
        });

        const datosInsertar = selected.map((i, index) => {
            return {
                IdLiquidacionDetalle: -(index + 1),
                IdIngresoDetalle: i.IdIngresoDetalle,
                IdStatus: 5,
                IdCategoriaLiquidacion: i?.IdCategoriaLiquidacion,
                IdIngreso: valoresIngreso.IdIngreso,
                MontoL: i.MontoAplicadoL,
                MontoD: i.MontoAplicadoD,
                TasaCambio: i.TasaCambio,
                IdUserCreo: userAuth.IdUser,
                FechaCreada: getDateTimeStringSQL(new Date()),
                IdUserEdit: userAuth.IdUser,
                FechaEdit: getDateTimeStringSQL(new Date()),
                IdCurrency: values.IdCurrency,
                IdReferenciaInv: valoresIngreso?.IdReferencia || null,
                IdLiquidacion: valoresIngreso?.IdLiquidacionContable > 0 ? valoresIngreso?.IdLiquidacionContable : null
            }

        });

        if (datosActualizar.length > 0) {
            const resultDetallesCXP = await postAplicarMontoDetalles(datosActualizar)
            if (resultDetallesCXP) {
                if (resultDetallesCXP[0]?.ERROR === 0) {
                    const resultDetallesL = await postLiquidacionesDetalles(datosInsertar)
                    if (resultDetallesL) {
                        if (resultDetallesL[0]?.ERROR === 0) {
                            toastShow(toast, 'success', 'Actualizado', resultDetallesL[0]?.MSJ)
                            if(!showPOColumn){
                                guardarIngresosBodega();
                            }else{
                                guardarIngresos();
                            }
                            if (op) {
                              op?.current.toggle(letraE)
                            }
                            setShowDialog(false)
                            setSelected([])
                        } else {
                            toastShow(toast, 'error', 'Actualizado', resultDetallesL[0]?.MSJ)
                        }
                    }
                } else {
                    toastShow(toast, 'error', 'Error',resultDetallesCXP[0]?.MSJ)
                    setSelected([])
                }
            }
        }
    }

    const colums = [
        {
            field: 'IdIngresoDetalle',
            header: 'ID',
            headerEn: 'ID',
            className: 'XXsmall',
            hidden: userAuth.IdRol === 1,
            frozen:true,
        },
        {
            field: 'FechaFactura',
            header: 'FechaFactura',
            headerEn: 'FechaFactura',
            Format: 'Date',
        },
        {
            field: 'NumeroIngreso',
            header: 'Ingreso',
            headerEn: 'Income',
            className: 'Xsmall',
        },
        {
            field: 'CodigoProducto',
            header: 'Código',
            headerEn: 'Code',
            className: 'Xsmall',
        },
        {
            field: 'NombreProducto',
            header: 'Producto',
            headerEn: 'Product',
            className: 'small',
        },
        {
            field: 'CategoriaLiquidacion',
            header: 'Categoria Liquidación',
            headerEn: 'Settlement Category',
            className: 'small',
            editable: true,
            Format: 'AutoComplete',
            value: 'IdCategoriaLiquidacion',
            label: 'CategoriaLiquidacion',
            items: categorias,
            onChange: ({ state, data: rowData, value, label, api, items, oldValue }) => {
                let row = { ...rowData }
                let tempo = [...data]

                if (state?.IdCategoriaLiquidacion !== oldValue.IdCategoriaLiquidacion) {
                    if (selected.length > 0) {
                        tempo.forEach((t) => {
                            selected.forEach((s) => {
                                if (t.IdIngresoDetalle === s.IdIngresoDetalle) {
                                    s.IdCategoriaLiquidacion = state?.IdCategoriaLiquidacion
                                    s.CategoriaLiquidacion = state?.CategoriaLiquidacion
                                }
                            })
                        })
                    }

                    if (row.IdIngresoDetalle) {
                        row.IdCategoriaLiquidacion = state?.IdCategoriaLiquidacion
                        row.CategoriaLiquidacion = state?.CategoriaLiquidacion

                        const index = data.findIndex((detail) => detail.IdIngresoDetalle === row.IdIngresoDetalle)
                        tempo[index] = row
                    }

                } else {
                    return
                }

                setSelected([])
                setData(tempo)
            }
        },
        {
            field: 'PurchaseOrder',
            header: 'OC',
            headerEn: 'PO',
            className: 'Xsmall',
        },
        {
            field: 'Factura',
            header: 'Factura',
            headerEn: 'Invoice',
            className: 'small',
        },
        {
            field: 'CustomerName',
            header: 'Proveedor',
            headerEn: 'Vendor',
            className: 'medium',
        },
        {
            field: 'NombreCategoria',
            header: 'TipoProducto',
            headerEn: 'Product Type',
            className: 'small',
        },
        {
            field: 'NombreSubcategoria',
            header: 'Sub Categoría',
            headerEn: 'Sub Category',
            className: 'small',
        },
        {
            field: 'TasaCambio',
            header: 'Tasa Cambio',
            headerEn: 'Tasa Cambio',
            className: 'Xsmall',
            Format: 'Currency',
        },

        {
            field: 'MontoAplicadoL',
            header: 'Monto Aplicar L',
            hidden: hiddenPriceColumn,
            Format: 'Currency',
            alignFrozen: 'right',
            className: 'Xsmall',
            editable: true,
            onChange: (data) => {
                if (data.newValue || data.newValue === 0) {
                    CambiarMontoAplicar(data?.data, data.newValue, 2)
                }
            },
        },
        {
            field: 'MontoAplicadoD',
            header: 'Monto Aplicar D',
            hidden: hiddenPriceColumn,
            Format: 'Currency',
            alignFrozen: 'right',
            className: 'Xsmall',
            onChange: (data) => {
                if (data.newValue || data.newValue === 0) {
                    CambiarMontoAplicar(data?.data, data.newValue, 1)
                }
            },
        },
        {
            field: 'BalanceLiquidacionL',
            header: 'Balance L',
            headerEn: 'Balance L',
            hidden: hiddenPriceColumn,
            Format: 'Currency',
            alignFrozen: 'right',
            className: 'Xsmall',
        },
        {
            field: 'BalanceLiquidacionD',
            header: 'Balance D',
            headerEn: 'Balance D',
            hidden: hiddenPriceColumn,
            alignFrozen: 'right',
            Format: 'Currency',
            className: 'Xsmall',
        },

    ]

    const table = {
        Data: data,
        Columns: colums,
        // onCellClicked: e => onChange(e, op),
        selected: selected,
        setSelected: setSelected,
    }

    const openOver = (e) => {
        op.current.toggle(e)
        setLoading(true)
        getInfo()
    }

    const columnsDet = [
      {
        header: "ID",
        headerEn: "ID",
        field: "IdIngresoDetalle",
        frozen: true,
        className: "XXsmall",
        hidden: userAuth.IdRol === 1,
      },
      {
        header: "Fecha Ingreso",
        headerEn: "Date Entry",
        field: "FechaIngreso",
        Format: "DateTime2",
        className: "small",
      },
      {
        header: "No. Orden",
        headerEn: "No. Order",
        field: "PurchaseOrder",
        className: " small",
        Format: "Modal",
      },
      {
        header: "Código",
        headerEn: "Code",
        field: "CodigoProducto",
        className: "Xsmall",
      },
      {
        header: "Producto",
        headerEn: "Product",
        field: "NombreProducto",
        className: "XXlarge",
      },
      {
        header: "Descripción",
        headerEn: "Description",
        field: "Descripcion",
      },
      {
        header: "Tipo Producto",
        headerEn: "Product Type",
        field: "NombreCategoria",
        className: "small",
      },
      {
        header: "Unidad",
        headerEn: "Unit",
        field: "UnitName",
        className: "medium",
      },
      serviciosNuevo
        ? {
            header: "Balance PO",
            headerEn: "Balance PO",
            field: "BalanceReservado",
            Sumary: "sum",
            Format: "Currency",
            className: "Xsmall",
          }
        : {
            header: "Balance PO",
            headerEn: "Balance PO",
            field: "Balance",
            Sumary: "sum",
            Format: "Currency",
            className: "Xsmall",
          },

      serviciosNuevo
        ? {
            header: "Ingreso",
            headerEn: "Income",
            field: "CantidadReservada",
            Sumary: "sum",
            Format: "Currency",
            // frozen: true,
            // alignFrozen: "right",
            className: "Xsmall",
          }
        : {
            header: "Ingreso",
            headerEn: "Income",
            field: "Ingreso",
            Sumary: "sum",
            Format: "Currency",
            // frozen: true,
            // alignFrozen: "right",
            className: "Xsmall",
          },
      ,
      {
        header: "Moneda",
        headerEn: "Currency",
        field: "Currency",
        className: "Xsmall",
      },
      {
        field: "TasaCambio",
        header: "Tasa Cambio",
        headerEn: "Exchange Rate",
        Format: "Decimal",
        Sumary: "sum",
        className: "Xsmall",
      },
      serviciosNuevo
        ? {
            field: "NombreCompuesto",
            header: "Construcción",
            headerEn: "Construccion",
            className: "XXXlarge",
          }
        : null,
      {
        field: "NombreCuenta",
        header: "Cuenta",
        headerEn: "Account",
        className: "XXlarge",
        flex: 1,
        minWidth: 500,
      },

      //EMBALAJE
      {
        headerName: "Embalaje",
        children: [
          {
            field: "EmbalajeL",
            header: "Monto L",
            Sumary: "sum",
            headerEn: "Monto L",
            hidden: hiddenPriceColumn,
            frozen: true,
            alignFrozen: "right",
            Format: "Currency",
            className: "small",
          },
          {
            field: "EmbalajeD",
            header: "Monto $",
            frozen: true,
            Sumary: "sum",
            headerEn: "Monto $",
            hidden: hiddenPriceColumn,
            alignFrozen: "right",
            Format: "Currency",
            className: "small",
          },
        ],
      },
      //DESADUANAJE
      {
        headerName: "Desaduanaje",
        children: [
          {
            field: "DesaduanajeL",
            header: "Monto L",
            Sumary: "sum",
            headerEn: "Monto L",
            hidden: hiddenPriceColumn,
            alignFrozen: "right",
            Format: "Currency",
            frozen: true,
            className: "small",
          },
          {
            field: "DesaduanajeD",
            header: "Monto $",
            frozen: true,
            Sumary: "sum",
            headerEn: "Monto $",
            hidden: hiddenPriceColumn,
            Format: "Currency",
            alignFrozen: "right",
            className: "small",
          },
        ],
      },
      // FLETE
      {
        headerName: "Flete",
        children: [
          {
            field: "FleteL",
            header: "Monto L",
            Sumary: "sum",
            frozen: true,
            headerEn: "Monto L",
            hidden: hiddenPriceColumn,
            Format: "Currency",
            alignFrozen: "right",
            className: "small",
          },
          {
            field: "FleteD",
            frozen: true,
            header: "Monto $",
            Sumary: "sum",
            headerEn: "Monto $",
            hidden: hiddenPriceColumn,
            alignFrozen: "right",
            Format: "Currency",
            className: "small",
          },
        ],
      },
      // OTROS COSTOS
      {
        headerName: "Otros Costos",
        children: [
          {
            field: "OtrosCostosL",
            hidden: hiddenPriceColumn,
            frozen: true,
            header: "Monto L",
            Sumary: "sum",
            alignFrozen: "right",
            headerEn: "Monto L",
            Format: "Currency",
            className: "small",
          },
          {
            field: "OtrosCostosD",
            header: "Monto $",
            hidden: hiddenPriceColumn,
            Sumary: "sum",
            frozen: true,
            alignFrozen: "right",
            headerEn: "Monto $",
            Format: "Currency",
            className: "small",
          },
        ],
      },

      // LEMPIRAS
      {
        headerName: "Lempiras",
        children: [
          {
            header: "PrecioL",
            Sumary: "sum",
            headerEn: "PriceL",
            field: "Precio",
            hidden: userAuth.IdRol === 1,
            hidden: hiddenPriceColumn,
            Format: "Currency",
          },
          {
            header: "Sub Total L",
            hidden: userAuth.IdRol === 1,
            hidden: hiddenPriceColumn,
            headerEn: "Sub Total L",
            Sumary: "sum",
            field: "SubTotal",
            Format: "Currency",
            className: "Xsmall",
          },
          {
            header: "ISV L",
            Sumary: "sum",
            hidden: userAuth.IdRol === 1,
            hidden: hiddenPriceColumn,
            headerEn: "TAX L",
            field: "ISVProductoL",
            Format: "Currency",
          },
          {
            header: "ISV 18 L",
            Sumary: "sum",
            hidden: userAuth.IdRol === 1,
            hidden: hiddenPriceColumn,
            headerEn: "TAX 18 L",
            field: "ISV18ProductoL",
            Format: "Currency",
            className: "Xsmall",
          },
          {
            header: "Desc. L",
            hidden: userAuth.IdRol === 1,
            hidden: hiddenPriceColumn,
            headerEn: "Disc. L",
            field: "Descuento",
            Sumary: "sum",
            Format: "Currency",
            className: "Xsmall",
          },
          {
            header: "MontoL",
            hidden: userAuth.IdRol === 1,
            hidden: hiddenPriceColumn,
            headerEn: "MontoL",
            field: "MontoL",
            Format: "Currency",
            Sumary: "sum",
            className: "small",
          },
        ],
      },

      {
        header: "CostoL",
        headerEn: "CostoL",
        hidden: userAuth.IdRol === 1,
        hidden: hiddenPriceColumn,
        field: "CostoL",
        Format: "Currency",
        Sumary: "sum",
        frozen: true,
        alignFrozen: "right",
        className: "small",
      },

      // DOLARES
      {
        headerName: "Dolares",
        children: [
          {
            header: "Precio $",
            Sumary: "sum",
            headerEn: "Price $",
            field: "PrecioD",
            hidden: userAuth.IdRol === 1,
            hidden: hiddenPriceColumn,
            Format: "Currency",
            className: "Xsmall",
          },
          {
            header: "Sub Total $",
            headerEn: "Sub Total $",
            Sumary: "sum",
            hidden: userAuth.IdRol === 1,
            hidden: hiddenPriceColumn,
            field: "SubTotalD",
            Format: "Currency",
            className: "Xsmall",
          },
          {
            header: "ISV $",
            hidden: userAuth.IdRol === 1,
            hidden: hiddenPriceColumn,
            headerEn: "TAX $",
            Sumary: "sum",
            field: "ISVProductoD",
            Format: "Currency",
            className: "Xsmall",
          },
          {
            header: "ISV 18% $",
            hidden: userAuth.IdRol === 1,
            hidden: hiddenPriceColumn,
            headerEn: "TAX 18% $",
            Sumary: "sum",
            field: "ISV18ProductoD",
            Format: "Currency",
            className: "Xsmall",
          },
          {
            header: "Desc. $",
            headerEn: "Disc. $",
            field: "DescuentoD",
            hidden: userAuth.IdRol === 1,
            hidden: hiddenPriceColumn,
            Sumary: "sum",
            Format: "Currency",
            className: "Xsmall",
          },

          {
            header: "Monto $",
            headerEn: "Monto $",
            hidden: userAuth.IdRol === 1,
            hidden: hiddenPriceColumn,
            field: "MontoD",
            Format: "Currency",
            Sumary: "sum",
            className: "small",
          },
        ],
      },

      {
        header: "Costo $",
        headerEn: "Costo $",
        hidden: userAuth.IdRol === 1,
        hidden: hiddenPriceColumn,
        field: "CostoD",
        Format: "Currency",
        Sumary: "sum",
        frozen: true,
        alignFrozen: "right",
        className: "small",
      },

      {
        header: "PrecioUL",
        Sumary: "sum",
        headerEn: "PriceUL",
        field: "PrecioUL",
        hidden: userAuth.IdRol === 1,
        hidden: hiddenPriceColumn,
        Format: "Currency",
        className: "Xsmall",
      },

      {
        header: "PrecioUD",
        Sumary: "sum",
        headerEn: "PriceUD",
        field: "PrecioUD",
        hidden: userAuth.IdRol === 1,
        hidden: hiddenPriceColumn,
        Format: "Currency",
        className: "Xsmall",
      },
    ];

    const tableDet = {
        Columns: columnsDet,
        Data: detalles,
    };

    const DialogFooter = (
        <React.Fragment>
            <Button
                label="Cancelar"
                icon="pi pi-times"
                className="p-button-text"
                onClick={()=> {setShowDialog(false); getIngreso()}}
            />
            <Button
                label={"Guardar"}
                icon="pi pi-check"
                className="p-button-text"
                onClick={() => {
                    guardarLiquidacion()
                }}
                loading={loading}
            />
        </React.Fragment>
    );


    return (
        <div>
            <Button ref={buttom} type="button" icon="pi pi-plus" className ='mt-2' onClick={(e) => openOver(e)} disabled={!habilitar} tooltip='Agregar Liquidación'/>
            <Toast ref={toast} />
            <OverlayPanel ref={op} showCloseIcon dismissable={false} onHide={close} style={{ width: '65vw', height: '65vh' }}  >
                <Loader loading={loading} querySelector={'#Ordenes'} />
                <div className='d-flex gap' style={{ justifyContent: 'end' }}>
                    <Dropdown
                        value={values.IdCurrency}
                        onChange={(e) => handleInputChange(e, 'IdCurrency')}
                        options={monedas}
                        optionValue="IdCurrency"
                        optionLabel="Currency"
                        style={{ width: '8vw' }}
                    />
                    <Button icon='pi pi-refresh' onClick={() => getInfo()} />
                    <Button icon='ri-check-double-line' onClick={(e) => {ActualizarInformacion(e)}} />
                </div>
                <div className='pt-2' style={{ width: '100%', height: '55vh' }} id='DetallesCXP'>
                    <AgGrid table={table} />
                </div>
            </OverlayPanel>

            <Dialog
                visible={showDialog}
                onHide={() => {setShowDialog(false); getIngreso()}}
                header={`Revise la información para realizar la liquidación ${info?.NumeroIngreso}`}
                style={{width: '90%', height: '70%'}}
                footer={DialogFooter}
            >
                <div className='d-flex'>
                  <div className="w-12">
                    <Card
                      titulo={<h6>Embalaje</h6>}
                      contenido={
                        <div className="flex-row" style={{ justifyContent: "center" }}>
                          <div className="p-float-label">
                            <InputNumber
                              value={info?.EmbalajeL}
                              onChange={handleInputChange}
                              allowLeadingZeros
                              id="EmbalajeL"
                              name="EmbalajeL"
                              thousandSeparator=","
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              disabled
                            />
                            <label htmlFor="username">Monto L</label>
                          </div>

                          <div className="mt-2 p-float-label">
                            <InputNumber
                              value={info?.EmbalajeD}
                              onChange={handleInputChange}
                              id="EmbalajeD"
                              name="EmbalajeD"
                              allowLeadingZeros      
                              disabled                          
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              thousandSeparator=","
                            />
                            <label htmlFor="username">Monto D</label>
                          </div>
                        </div>
                      }
                    />
                  </div>
  
                  <div className="w-12">
                    <Card
                      titulo={<h6>Desaduanaje</h6>}
                      contenido={
                        <div className=" flex-row" style={{ justifyContent: "center" }}>
                          <div className="p-float-label">
                            <InputNumber
                              value={info.DesaduanajeL}
                              onChange={handleInputChange}
                              allowLeadingZeros
                              thousandSeparator=","
                              id='DesaduanajeL'
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              name='DesaduanajeL'
                              disabled

                            />
                            <label htmlFor="username">Monto L</label>
                          </div>
                          <div className=" mt-2 p-float-label">
                            <InputNumber
                              value={info.DesaduanajeD}
                              onChange={handleInputChange}
                              allowLeadingZeros
                              id='DesaduanajeD'
                              name='DesaduanajeD'        
                              minFractionDigits={3}
                              maxFractionDigits={3}                        
                              thousandSeparator=","
                              disabled

                            />
                            <label htmlFor="username">Monto D</label>
                          </div>
                        </div>
                      }
                    />
                  </div>
  
                  <div className="w-12">
                    <Card
                      titulo={<h6>Flete</h6>}
                      contenido={
                        <div className=" flex-row" style={{ justifyContent: "center" }}>
                          <div className="p-float-label">
                            <InputNumber
                              value={info.FleteL}
                              onChange={handleInputChange}
                              allowLeadingZeros
                              thousandSeparator=","
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              id='FleteL'
                              name='FleteL'
                              disabled
                            />
                            <label htmlFor="username">Monto L</label>
                          </div>
                          <div className=" mt-2 p-float-label">
                            <InputNumber
                              value={info.FleteD}
                              onChange={handleInputChange}
                              allowLeadingZeros
                              thousandSeparator=","
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              id='FleteD'
                              name='FleteD'
                              disabled
                            />
                            <label htmlFor="username">MontoD</label>
                          </div>
                        </div>
                      }
                    />
                  </div>
  
                  <div className="w-12">
                    <Card
                      titulo={<h6>Otros Costos</h6>}
                      contenido={
                        <div className=" flex-row" style={{ justifyContent: "center" }}>
                          <div className="p-float-label">
                            <InputNumber
                              value={info.OtrosCostosL}
                              onChange={handleInputChange}
                              allowLeadingZeros
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              thousandSeparator=","
                              id='OtrosCostosL'
                              name='OtrosCostosL'
                              disabled
                            />
                            <label htmlFor="username">Monto L</label>
                          </div>
                          <div className=" mt-2 p-float-label">
                            <InputNumber
                              value={info.OtrosCostosD}
                              onChange={handleInputChange}
                              allowLeadingZeros
                              minFractionDigits={3}
                              maxFractionDigits={3}
                              thousandSeparator=","
                              id='OtrosCostosD'
                              name='OtrosCostosD'
                              disabled
                            />
                            <label htmlFor="username">Monto D</label>
                          </div>
                        </div>
                      }
                    />
                  </div>
                </div>

                <Card
                    contenido={
                        <div style={{ height: "25vh" }}>
                            <AgGrid table={tableDet} />
                        </div>
                    }
                />
            </Dialog>
        </div>
    )
}

export default OverlayLiquidaciones